export const SITE_MEMBERS_PERMISSIONS_FETCH_REQUESTED =
  'SITE_MEMBERS_PERMISSIONS_FETCH_REQUESTED';
export const SITE_MEMBERS_PERMISSIONS_FETCH_SUCCEEDED =
  'SITE_MEMBERS_PERMISSIONS_FETCH_SUCCEEDED';
export const SITE_MEMBERS_PERMISSIONS_FETCH_FAILED =
  'SITE_MEMBERS_PERMISSIONS_FETCH_FAILED';

/**
 * Actions related to role simulation
 */
export const SIMULATE_ROLE_STARTED = 'SIMULATE_ROLE_STARTED' as const;
export const SIMULATE_ROLE_ENDED = 'SIMULATE_ROLE_ENDED' as const;
export const DEFAULT_SIMULATED_SITE_ROLE_SET =
  'DEFAULT_SIMULATED_SITE_ROLE_SET' as const;
export const DEFAULT_SIMULATED_SITE_ROLE_CLEARED =
  'DEFAULT_SIMULATED_SITE_ROLE_CLEARED' as const;
